import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal,
  InMemoryBoolean
} from "pbas-vue-components";

import { translateProperty } from '../trans'
import store from '@/store'

const PortalFilesHeaders = [
  new InMemoryHeader({
      title: "Id",
      type: new InMemoryString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1
  }),
  new InMemoryHeader({
      title: "headers.downloadcategories.path",
      type: new InMemoryString("Name", {
          getString: function(item) {
            return `${item.Name}`;
          },
          getHtml: (item, type) => {
              return `<a href=${item.Name} target="_blank">${type.getString(item, type)}</a>`
          }
      }),
      sortable: false,
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      version: 1
  }),
  // new InMemoryHeader({
  //   title: "globals.name",
  //   type: new InMemoryString("Name", {
  //       getString: function(item) {
  //         return item.Name;
  //       },
  //   }),
  //   sortable: true,
  //   visible: true,
  //   allowVisibilityChange: true,
  //   searchable: true,
  //   version: 1
// }),
];
export default PortalFilesHeaders;